module.exports = __webpack_public_path__ + "static/img/counp6.7d0dcb3e.png";